import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { GridModalData } from '@app/core/components/grid/modals/grid-modal.service';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { DocArcService, DocumentCategoryItem } from '@app/services/doc-arc.service';

@GridModalComponent('EditDocarcDocumentCategoryTs')
@Component({
    selector: 'tt-edit-docarc-document-category-dialog',
    templateUrl: './edit-docarc-document-category-dialog.component.html',
    styleUrls: ['./edit-docarc-document-category-dialog.component.css'],
})
export class EditDocarcDocumentCategoryDialogComponent implements OnInit {
    public get?: EditDocarcDocumentCategoryGet;

    public documentCategories: DocumentCategoryItem[] = [];

    public saving = false;

    constructor(@Inject(MAT_DIALOG_DATA) private data: GridModalData, private dialogRef: MatDialogRef<EditDocarcDocumentCategoryDialogComponent>, private datatask: DataTaskService, private docarc: DocArcService, private modal: ModalService) {}

    public async save() {
        try {
            this.saving = true;

            const response = (await this.datatask.Post(3729, { datatask_keyno: this.data.loadData?.method, ...this.get }))[0];

            if (response?.errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.errormessage });
            } else {
                this.dialogRef.close();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(3728))[0];
    }

    private async loadDocumentCategories() {
        this.documentCategories = await this.docarc.getDocumentCategories();
    }

    ngOnInit(): void {
        this.loadGet();
        this.loadDocumentCategories();
    }
}

interface EditDocarcDocumentCategoryGet {
    doccategory_keyno: string | number;
}
